import { combineReducers } from 'redux';
import authReducer from './auth.reducer';
import manageInterviewersModalReducer from './Interviews/manageInterviewersModal.reducer';
import companyReducer from './company.reducer';
import quotasReducer from './quotas.reducer';
import recruiterReducer from './recruiter.reducer';
import modulesReducer from './modules.reducer';
import jobRolesReducer from './Interviews/jobRoles.reducer';
import hiringRolesReducer from './Interviews/hiringRoles.reducer';
import breadcrumbsReducer from './breadcrumbs.reducer';
import modalReducer from './modal.reducer';
import alertReducer from './alert.reducer';
import interviewersReducer from './Interviews/interviewers.reducer';
import loaderReducer from './loader.reducer';
import candidatesReducer from './Interviews/candidates.reducer';
import interviewLibraryReducer from './Interviews/library.reducers';
import interviewTechnologiesReducer from './Interviews/technologies.reducer';
import aiInterviewReducer from './AiInterviews/aiInterview.reducer';
import rolesReducer from './RecruiterDashboard/roles.reducer';
import backOfficeReducer from './RecruiterDashboard/backoffice.reducer';
import campaignsReducer from './dhwani/campaings.reducer';
import campaignReducer from './dhwani/campaign.reducer';
import campaignSummaryReducer from './dhwani/campaignSummary.reducer';
import cocallerAppSettingsReducer from './dhwani/cocallerAppSettings.reducer';
import toastReducer from './toast.reducer';
import teamMemberStatsReducer from './teamMemberStats.reducer';
import ledgerDetailsReducer from './ledgerDetails.reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  manageInterviewersModal: manageInterviewersModalReducer,
  company: companyReducer,
  teamMembersStats: teamMemberStatsReducer,
  quotas: quotasReducer,
  hiringRoles: hiringRolesReducer,
  campaigns: campaignsReducer,
  campaign: campaignReducer,
  campaignSummary: campaignSummaryReducer,
  cocallerAppSettings: cocallerAppSettingsReducer,
  jobRoles: jobRolesReducer,
  candidates: candidatesReducer,
  recruiter: recruiterReducer,
  breadcrumbs: breadcrumbsReducer,
  modal: modalReducer,
  alert: alertReducer,
  interviewers: interviewersReducer,
  loader: loaderReducer,
  interviewLibrary: interviewLibraryReducer,
  technologies: interviewTechnologiesReducer,
  modules: modulesReducer,
  aiInterview: aiInterviewReducer,
  roles: rolesReducer,
  backoffice: backOfficeReducer,
  toast: toastReducer,
  ledgerDetails: ledgerDetailsReducer,
});

export default rootReducer;
